import React, { Component } from 'react';

import API from '@api';
import { getBtnClass } from '@triage-help/helpers';

class Confirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: 'Loading street name.',
      locationLoaded: false,
    };
  }

  componentDidMount() {
    const channels = [];

    // If there are more than 50 channels in the list, it's probably all channels.
    if (this.props.channels.length < 50) {
      this.props.channels.forEach(c => {
        channels.push(c.value);
      });
    }

    API.getStatuscheck(channels, this.props.location).then(
      (data => {
        this.setState({
          location: data.address,
          locationLoaded: true,
        });
        localStorage.setItem('userPostcode', data.address);
        this.props.updateStatus(data);
      }).bind(this),
    );
  }

  render() {
    const { step, goToPrev } = this.props;
    const prevLink = step.link.find(l => l.type == 'prev');
    const confirmationLink = step.link.find(l => l.type == 'confirmation');

    return (
      <div className="fv-triage-card">
        <div className="row">
          <div className="col-sm-12 col-md-7 fv-triage-card__content">
            <div dangerouslySetInnerHTML={{ __html: step.content }} />
          </div>
          <div className="col-sm-12 col-md-5 fv-triage-card__side">
            <div className="fv-triage-card__confirmation">
              <p>{this.state[step.confirmationVariable]}</p>
              {confirmationLink && (
                <button
                  className={getBtnClass(confirmationLink.type)}
                  onClick={() => this.props.goToStep(confirmationLink.target)}
                >
                  {confirmationLink.text}
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12 fv-triage-card__links">
            {prevLink && (
              <button
                className={getBtnClass(prevLink.type)}
                onClick={() => goToPrev()}
              >
                {prevLink.text}
              </button>
            )}
            <div className="fv-triage-card__links__next">
              {step.link
                .filter(l => l.type != 'prev' && l.type != 'confirmation')
                .map((link, i) => {
                  return (
                    <button
                      className={getBtnClass(
                        link.type,
                        this.state.locationLoaded,
                      )}
                      key={i}
                      onClick={() => this.props.goToStep(link.target)}
                    >
                      {link.text}
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Confirmation;
